import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ApplicationState = {
  errorMessage: string;
};

const initialState: ApplicationState = {
  errorMessage: '',
};

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    showErrorMessage: (state, action: PayloadAction<string>): void => {
      state.errorMessage = action.payload;
    },
  },
});

export const { showErrorMessage } = applicationSlice.actions;

export default applicationSlice.reducer;
